
var dateToday = new Date();
var dateEarliest = new Date("01/01/2019");

MCApp.directive('jqdatepicker', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            element.datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: "dd/mm/yy",
                minDate: dateToday
            });
        }
    };
});
